import(/* webpackMode: "eager" */ "/codebuild/output/src3716879585/src/padamiMainWebsite/app/page.jsx");
